import React from "react";
import PropTypes from "prop-types";
import { Img, TextWrapper, Wrapper } from "../../constants/common/StyledGlobalConstants";
import Arrow from "../../assets/icons/blue-arrow-right.svg";
import styled from "styled-components";

const CustomisedWrapper = styled(Wrapper)`
  &:focus {
    outline: auto !important;
  }
`

const Cards = ({ width, title, subTitle, linkText, onClickHandle, textId }) => {
  return (
    <Wrapper
      borderRadius="0.5rem"
      border="1px solid #D8DADA"
      background="#FFF"
      display="flex"
      width={width}
      padding="1.5rem"
      flexDirection="column"
      justifyContent="center"
      alignItems="flex-start"
      gap="1.5rem"
    >
      <Wrapper gap="0.5rem" display="flex" flexDirection="column" justifyContent="center" alignItems="flex-start" alignSelf="stretch">
        <TextWrapper
          aria-label={title}
          // role="heading"
          aria-level="2"
          fontFamily="neue-haas-grotesk-display"
          fontSize="1.25rem"
          fontWeight="700"
          lineHeight="1.5rem"
        >
          {title}
        </TextWrapper>
        <TextWrapper
          aria-label={subTitle}
          fontSize="0.875rem"
          fontWeight="400"
          lineHeight="1.25rem"
        >
          {subTitle}
        </TextWrapper>
      </Wrapper>
      <CustomisedWrapper display="flex" alignItems="center" width="100%" tabIndex="0" aria-label={linkText} onClick={onClickHandle} onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClickHandle()} onTouchEnd={onClickHandle}
      // role="button"
        >
        <TextWrapper
          color="#0077B4"
          fontSize="0.875rem"
          fontWeight="400"
          lineHeight="1.25rem"
          style={{ flex: "1 0 0", cursor: "pointer" }}
          id={textId}
        >
          {linkText}
        </TextWrapper>
        <Img src={Arrow} alt="arrow" aria-hidden="true" style={{ cursor: "pointer" }}></Img>
      </CustomisedWrapper>
    </Wrapper>
  );
};

Cards.propTypes = {
  width: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  linkText: PropTypes.string,
  onClickHandle: PropTypes.func,
  textId: PropTypes.string
};

export default Cards;
